import { render, staticRenderFns } from "./driverView.vue?vue&type=template&id=43537e9a&scoped=true&"
import script from "./driverView.vue?vue&type=script&lang=js&"
export * from "./driverView.vue?vue&type=script&lang=js&"
import style0 from "./driverView.vue?vue&type=style&index=0&id=43537e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43537e9a",
  null
  
)

component.options.__file = "driverView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDataTable,
  VFlex,
  VProgressCircular,
})
